// OTP session for one browser tab. The keys "validateotp" and "otp" are read all
// over the app, so they stay; "otpAwb" ties them to the AWB the OTP was issued for.
// The OTP is stored JSON-encoded ("\"724720\""): always read it through getOtpSession.

const norm = (awb) => String(awb || "").trim().toUpperCase();
const DERIVED = ["delivery_otp", "deliveryotp", "delivery-otp", "showdetails"];

export const saveOtpSession = (awb, otp) => {
  sessionStorage.setItem("validateotp", "true");
  sessionStorage.setItem("otp", JSON.stringify(otp));
  sessionStorage.setItem("otpAwb", norm(awb));
};

export const clearOtpSession = () => {
  ["validateotp", "otp", "otpAwb", ...DERIVED].forEach((k) => sessionStorage.removeItem(k));
};

// Decoded OTP, or null when there is no session.
export const getOtpSession = () => {
  if (!sessionStorage.getItem("validateotp")) return { valid: false, otp: null, awb: null };
  const raw = sessionStorage.getItem("otp");
  let otp = raw;
  try {
    otp = JSON.parse(raw);
  } catch (e) {
    // Older code stored the value as plain text.
  }
  return { valid: true, otp, awb: sessionStorage.getItem("otpAwb") };
};

// Call before reading the session on a page for `awb`: a session for another AWB
// (or one saved before the AWB was recorded) is dropped, so the buyer is asked
// for the OTP of this shipment.
export const ensureOtpSessionFor = (awb) => {
  if (!awb || !sessionStorage.getItem("validateotp")) return;
  if (sessionStorage.getItem("otpAwb") !== norm(awb)) clearOtpSession();
};
